export default {"src":"/_next/static/image/public/images/flags/flag_973.bc59567064ae9c7a13764e153f249e95.svg","height":16,"width":24};